var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext } from 'react';
import { EditorContext } from '../../EditorStore';
import { useSelector } from '../../reduxConnect';
import { getLang } from '../../selector/setting';
import { normalizeCellSpacing } from '../../utils/getCellSpacing';
import NoopProvider from '../Cell/NoopProvider';
/**
 * @returns the store object of the current editor. Contains the redux store.
 */
export var useEditorStore = function () { return useContext(EditorContext); };
export var OptionsContext = createContext({
    allowMoveInEditMode: true,
    allowResizeInEditMode: true,
    cellPlugins: [],
    languages: [],
    pluginsWillChange: false,
});
/**
 * @returns the options object of the current Editor. @see Options type for more information
 */
export var useOptions = function () { return useContext(OptionsContext); };
/**
 * @returns the an object with a single `t` function for ui translations
 */
export var useUiTranslator = function () {
    var uiTranslator = useOptions().uiTranslator;
    return {
        t: function (key) {
            var _a;
            return (_a = uiTranslator === null || uiTranslator === void 0 ? void 0 : uiTranslator(key)) !== null && _a !== void 0 ? _a : key;
        },
    };
};
/**
 * @returns the current language
 */
export var useLang = function () {
    return useSelector(getLang);
};
/**
 * @returns cell spacing for the current cell sub-tree
 */
export var useCellSpacing = function () {
    return normalizeCellSpacing(useOptions().cellSpacing);
};
/**
 * @returns a Provider/value tuple that can be used to override cell spacing for a subtree of cells
 */
export var useCellSpacingProvider = function (cellSpacing) {
    var options = useOptions();
    var value = React.useMemo(function () { return (__assign(__assign({}, options), { cellSpacing: normalizeCellSpacing(cellSpacing) })); }, [options, JSON.stringify(cellSpacing)]);
    if (typeof cellSpacing === 'undefined' || cellSpacing == null) {
        return [NoopProvider, undefined];
    }
    else {
        return [OptionsContext.Provider, value];
    }
};
//# sourceMappingURL=options.js.map